import { Injectable } from "@angular/core";
import { DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase, getDefaultColumnStyle } from "@devwareapps/devware-cap";
import { CodeValuePermitType, PermitRequestEntity, PermitsMetaDataItemNames } from "../meta-data/permits-meta-data.service";
import { PermitRequestService } from '../services/permit-request.service';
//import { _ } from 'lodash';

@DwGridColumn({
    keyName: 'permit-request-type-merged-column',
    display: 'List of Permit Request Types',
    decoratorType: DwDecoratorType.service,
    isGlobal: false,
    parentItemName:  PermitsMetaDataItemNames.PermitRequest,
    allowAttr: true,
    requireAttr: true,
    allowAction: true,
    order: 1,
    columnStyleFunc: getDefaultColumnStyle,
})
@Injectable()
export class PermitRequestMergedTypeRendererService implements DwGridColumnRendererBase {
    constructor(
        private permitRequestService: PermitRequestService,
    ) { }

    renderColumn(columnConfig: DwGridColumnDef<any>): (params: DwColumnRendererParams) => any {
        return (params) => {
            const data: PermitRequestEntity = params.data;
            if (!data) return "";
            columnConfig.columnFormatType = DwColumnFormatType.standard;

            let types: any[] = [];
            if (data.HasDataVoice) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.DataVoice));
            if (data.HasCCTV) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.CCTV));
            if (data.HasAudioVisual) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.AudioVisual));
            if (data.HasFireAlarm) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.FireAlarm));
            if (data.HasElectrical) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.Electrical));
            if (data.HasAccessControl) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.AccessControl));
            if (data.HasBurglarAlarm) types.push(this.permitRequestService.getPermitTypeName(CodeValuePermitType.BurglarAlarm));
            return types.join(", ");
        }
    }
}